var isGeneratedChatName = function (name) { return Boolean(name.match(/Chat \d+/)); };
export default isGeneratedChatName;
